<app-videos-overview *ngIf="currentVideo==null" (goToVideo)="cmpToDisplay($event)"></app-videos-overview>
<app-video-play *ngIf="currentVideo!=null"  (goToVideo)="cmpToDisplay($event)" [courseVideo]="currentVideo"></app-video-play>